import React from 'react';
import PropTypes from 'prop-types';

import useBazaarVoice from 'hooks/useBazaarVoice';
import BVHelmet from './BVHelmet';

const BVRatingSummary = ({ productId }) => {
  useBazaarVoice();

  if (!productId) return null;

  return (
    <>
      <BVHelmet />
      <div data-bv-show="rating_summary" data-bv-product-id={productId} />
    </>
  );
};

BVRatingSummary.propTypes = {
  productId: PropTypes.string,
};

export default BVRatingSummary;
